import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesNotificationEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-notification-edit',
	path: '/secure/admin/EditNotifications([!%]?[\\w]*).jspa',
};
